import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, FileBarChart, BookOpen, Bot, ArrowRight } from "lucide-react";
import { listCompanies } from "@/lib/api";
import { TourLauncher } from "@/components/TourLauncher";

export const CompaniesSection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    listCompanies()
      .then((d) => setItems(d.companies || []))
      .catch(() => setItems([]));
  }, []);

  if (!items.length) return null;
  return (
    <section className="mt-10" data-testid="companies-section">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">Clientes</p>
          <h2 className="mt-2 font-display text-2xl font-medium text-slate-900">Empresas ({items.length})</h2>
        </div>
        <TourLauncher />
      </div>
      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        {items.map((c) => (
          <CompanyCard key={c.session_id} c={c} />
        ))}
      </div>
    </section>
  );
};

const CompanyCard = ({ c }) => (
  <article
    className="border border-slate-200 bg-white p-6 transition-colors hover:border-accent-blue/50"
    data-testid={`company-card-${c.company_slug}`}
  >
    <div className="flex items-start justify-between gap-4">
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 items-center justify-center bg-slate-900 text-accent-blue-light">
          <Building2 className="h-4 w-4" />
        </div>
        <div>
          <h3 className="font-display text-lg font-medium text-slate-900">{c.company}</h3>
          <p className="text-[10px] uppercase tracking-[0.2em] text-accent-blue">{c.industry || "—"}</p>
        </div>
      </div>
      {c.demo && (
        <span className="bg-amber-50 px-2 py-0.5 text-[10px] uppercase tracking-[0.18em] text-amber-700">Demo</span>
      )}
    </div>
    <p className="mt-4 line-clamp-2 text-sm text-slate-600">{c.context}</p>
    <p className="mt-3 text-[11px] uppercase tracking-[0.16em] text-slate-500">
      {c.stats.departments} departamentos · {c.stats.people} cargos · {c.stats.activities} actividades · {c.kbl_documents} documentos KBL
    </p>
    <div className="mt-4 flex flex-wrap gap-2">
      {c.agents.map((a) => (
        <Link
          key={a.slug}
          to={`/agentes/${a.slug}`}
          className="inline-flex items-center gap-1 border border-slate-200 px-2 py-1 text-[11px] text-slate-700 hover:border-slate-900 hover:text-slate-900"
          data-testid={`company-agent-${a.slug}`}
        >
          <Bot className="h-3 w-3" /> {a.department}
        </Link>
      ))}
    </div>
    <div className="mt-5 flex flex-wrap gap-4 border-t border-slate-100 pt-4 text-[11px] uppercase tracking-[0.18em]">
      <Link to={`/informe/${c.session_id}`} className="inline-flex items-center gap-1 text-slate-900 hover:text-accent-blue" data-testid={`company-report-${c.company_slug}`}>
        <FileBarChart className="h-3.5 w-3.5" /> Informe ABC <ArrowRight className="h-3 w-3" />
      </Link>
      <Link to={`/admin/kbl?empresa=${encodeURIComponent(c.company)}`} className="inline-flex items-center gap-1 text-slate-600 hover:text-accent-blue" data-testid={`company-kbl-${c.company_slug}`}>
        <BookOpen className="h-3.5 w-3.5" /> Biblioteca KBL
      </Link>
    </div>
  </article>
);
